import { render, staticRenderFns } from "./InList.vue?vue&type=template&id=2a01cb2c&scoped=true"
import script from "./InList.vue?vue&type=script&lang=js"
export * from "./InList.vue?vue&type=script&lang=js"
import style0 from "./InList.vue?vue&type=style&index=0&id=2a01cb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a01cb2c",
  null
  
)

export default component.exports